import { Link } from 'react-router-dom'

const NotFoundPage = () => {
  return (
    <main className="info-page">
      <Link to="/" className="info-page__back">Shelf Discovery</Link>
      <section className="info-page__content">
        <p className="info-page__eyebrow">404</p>
        <h1>That shelf is empty.</h1>
        <p>The page you are looking for does not exist yet.</p>
      </section>
    </main>
  )
}

export default NotFoundPage
